import { Link } from "react-router";

import { Alert, PageHeader } from "@/components/ui";
import { usePageMeta } from "@/lib/page-meta";

/**
 * The 404, and the one thing it must not be mistaken for.
 *
 * A visitor who reaches this page after typing a vendor name is one keystroke
 * away from concluding that the vendor is not official. It is not that answer —
 * `/verify/:id` is, and it says so in words. So this page points there rather
 * than leaving someone to guess.
 */
export function NotFoundPage() {
  usePageMeta({
    title: "Halaman tidak ditemukan",
    description: "Alamat yang Anda buka tidak ada di portal resmi AsetQu.",
  });

  return (
    <div className="page-shell">
      <PageHeader
        context="404"
        title="Halaman tidak ditemukan"
        description="Alamat yang Anda buka tidak ada di portal ini."
      />

      <Alert tone="warn">
        Ini <strong>bukan</strong> jawaban tentang status sebuah vendor atau utility. Halaman ini
        hanya berarti alamatnya tidak ada. Untuk memeriksa apakah sesuatu resmi, buka{" "}
        <Link to="/verify/ASETQU_MEMBERSHIP" className="underline decoration-dotted">
          halaman verifikasi
        </Link>{" "}
        dan masukkan ID-nya di sana — halaman itu membedakan &ldquo;tidak terdaftar&rdquo; dari
        &ldquo;belum bisa diperiksa&rdquo;.
      </Alert>

      <p className="mt-6 text-sm text-ink-muted">
        <Link to="/" className="underline decoration-dotted underline-offset-4">
          Kembali ke beranda
        </Link>
      </p>
    </div>
  );
}
